var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Step-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.68338,0 L8.81789394,0 C8.64307367,0 8.50137062,0.141801625 8.50137062,0.316575875 C8.50137062,0.491495166 8.64307367,0.633200097 8.81789394,0.633200097 L10.9190248,0.633200097 L7.0927524,4.45957167 C6.96908253,4.58319484 6.96908253,4.78364132 7.0927524,4.90726449 C7.21637393,5.03088766 7.41681775,5.03093601 7.54048762,4.90726449 L11.36676,1.08094127 L11.3668083,3.18200333 C11.3668083,3.35692262 11.5085597,3.49862755 11.68338,3.49862755 C11.7707901,3.49862755 11.849933,3.46318923 11.9072718,3.40589809 C11.9645138,3.34860694 11.9999517,3.26946297 12,3.18200333 L11.9999517,0.316575875 C11.9999517,0.141753278 11.8582003,0 11.68338,0",
    id: "Fill-1",
    stroke: "#7c7c7c",
    strokeWidth: 0.8,
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6.95905882 L12,11.2470588 C12,11.6611765 11.6611765,12 11.2470588,12 L0.752941176,12 C0.338823529,12 0,11.6611765 0,11.2470588 L0,0.752941176 C0,0.338823529 0.338823529,0 0.752941176,0 L5.12282353,0",
    id: "Stroke-3",
    stroke: "#7c7c7c",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.be8439388765598f981b85c599ae6085.svg";
export { ForwardRef as ReactComponent };